export const ResumeParsingCacheBusterDefaultVersion = '1';

export const constructResumeParsingCacheBusterKey = ({
  resumeContentsCacheKey,
  cacheBusterVersion,
}: {
  resumeContentsCacheKey: string;
  cacheBusterVersion: string;
}) => {
  if (cacheBusterVersion === ResumeParsingCacheBusterDefaultVersion) {
    return resumeContentsCacheKey;
  } else {
    return `${resumeContentsCacheKey}-${cacheBusterVersion}`;
  }
};
